import { useQuery } from '@tanstack/react-query';

import { makeRequest } from '@app/utils';

export interface LocationDto {
  id: string;
  name: string;
  code: string;
  libraryId: string;
  discoveryDisplayName?: string;
}

export interface LocationsDto {
  locations: LocationDto[];
}

const locationsFetchLimit = 1000;

export const useLocationsFetch = ({
  isEnabled = true,
}: {
  isEnabled?: boolean;
} = {}) =>
  useQuery<LocationsDto, unknown, LocationsDto['locations']>(
    ['locations'],
    () =>
      makeRequest<LocationsDto>({
        url: '/opac-inventory/locations',
        params: { limit: locationsFetchLimit },
      }),
    {
      enabled: isEnabled,
      refetchOnMount: false,
      select: ({ locations }) => locations,
    }
  );
